import { ReactNode } from 'react';
import styled from 'styled-components';

interface IContent {
    children: ReactNode;
}

export default function Content({ children }: IContent) {
    return (
        <Container>
            {children}
        </Container>
    )
}

const Container = styled.main`
    padding: 30px;
    height: 100vh;
`;